export function attachQuerySocketEvents(socket, client, userId, onAccessDenied) {
  const prefix = ["account", userId];
  const classesChanged = () => {
    client.cancelQueries({ queryKey: [...prefix, "classes"], type: "inactive" });
    client.invalidateQueries({ queryKey: [...prefix, "classes"], type: "inactive", refetchType: "none" });
    client.invalidateQueries({ queryKey: [...prefix, "members"] });
  };
  const feedChanged = () => {
    client.cancelQueries({ queryKey: [...prefix, "feed"], type: "inactive" });
    client.invalidateQueries({ queryKey: [...prefix, "feed"], type: "inactive", refetchType: "none" });
  };
  const denied = () => { client.clear(); onAccessDenied(); };
  const messagesChanged = () => {
    for (const type of ["dm-list", "dm-messages"]) {
      client.invalidateQueries({ queryKey: [...prefix, type], refetchType: "none" });
    }
  };
  const membershipChanged = event => {
    if (String(event?.removedId || event?.leftMemberId) === String(userId)) denied();
    else client.invalidateQueries({ queryKey: prefix });
  };
  const handlers = [
    ["class:video-status", event => client.invalidateQueries({ queryKey: event?.groupId ? [...prefix, "classes", String(event.groupId)] : [...prefix, "classes"] })],
    ["class:video-ready", () => client.invalidateQueries({ queryKey: [...prefix, "classes"] })],
    ...["message:new", "message:viewed", "message:deleted"].map(event => [event, messagesChanged]),
    ...["class:expired", "class:rescheduled", "class:deleted", "class:ended", "class:recording-ready"].map(event => [event, classesChanged]),
    ...["workspace:memberJoin", "workspace:roleChanged", "workspace:memberRemoved", "workspace:memberLeft"].map(event => [event, membershipChanged]),
    ["feed:updated", feedChanged], ["course:access-denied", event => {
      if (["SUBSCRIPTION_REQUIRED", "COURSE_ACCESS_DENIED", "COURSE_NOT_FOUND"].includes(event?.code)) denied();
    }],
  ];
  handlers.forEach(([event, handler]) => socket.on(event, handler));
  return () => handlers.forEach(([event, handler]) => socket.off(event, handler));
}
